module.exports = __webpack_public_path__ + "media/images/chat-c4c211cbda2e02b01b380da1cc5b7f0d.svg";